module.exports = __webpack_public_path__ + "static/media/his-dark-materials.8925c126.jpg";